import {Card, Box, Typography} from '@material-ui/core';
import {useEffect, useState} from "react";
import {useTranslate} from "react-admin";
import CircularProgress from "@material-ui/core/CircularProgress";

import {dashboard} from '../../styles/dashboard';
import axiosForApi from "../../config/axios-for-api";
import StatHeader from "./StatHeader";

const Loading = () => {
    return (
        <Box display={'flex'} justifyContent={'center'}>
            <CircularProgress size={28.8}/>
        </Box>
    );
}

const StatResult = ({classes, nrOffers, nrOrders, conversionRate}: any) => {
    return (
        <Typography className={classes.statsTotal} color="textSecondary">
            {nrOffers} / {nrOrders} / {conversionRate}
        </Typography>
    );
}


const OffersOrdersConversionRateLast12Months = ({countries}: { countries: string[] | null }) => {
    const classes = dashboard();
    const translate = useTranslate();

    const [statsData, setStatsData] = useState({
        nr_offers_fmt: '',
        nr_orders_fmt: '',
        conversion_rate_fmt: ''
    });
    const [shouldLoadStatsData, setShouldLoadStatsData] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancel = false;

        const loadStatsData = async () => {
            const {data} = await axiosForApi.get('api/admin/stats/offers-orders-conversion-rate-last-12-months', {
                params: {
                    countries
                }
            });

            if(!cancel) {
                setLoading(false);
                setStatsData(data ?? null);
                setShouldLoadStatsData(false);
            }
        }

        shouldLoadStatsData && loadStatsData();

        return () => {
            cancel = true;
        }
    }, [shouldLoadStatsData, countries]);

     useEffect(() => {
        setLoading(true);
        setShouldLoadStatsData(true);
    }, [countries]);

    return (
        <Card className={classes.card}>
            <Box p={2}>
                <StatHeader
                    justifyContent='center'
                    // title='Angebote / Bestellungen aus Angeboten / Conversion Angebot2Bestellung'
                    title={translate('resources.admin/dashboard.headers.offers-orders-conversion-rate-last-12-months')}
                    help="resources.admin/dashboard.help.offers-orders-conversion-rate-last-12-months"
                />
                {loading ? <Loading/> : <StatResult
                    classes={classes}
                    nrOffers={statsData.nr_offers_fmt}
                    nrOrders={statsData.nr_orders_fmt}
                    conversionRate={statsData.conversion_rate_fmt}
                />}
            </Box>
        </Card>
    );
}

export default OffersOrdersConversionRateLast12Months;
